import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PendingAttachment } from "../../features/messages/hooks/useAttachmentUpload";

interface PendingAttachmentsProps {
  items: PendingAttachment[];
  onRemove: (localId: string) => void;
}

/** The attachments waiting in the composer: name, upload progress, Remove. */
const PendingAttachments = ({ items, onRemove }: PendingAttachmentsProps) => {
  const { t } = useTranslation();
  if (items.length === 0) return null;

  return (
    <ul className="mb-2 flex flex-col gap-1" aria-live="polite" data-testid="pending-attachments">
      {items.map((item) => {
        const percent = Math.round(item.progress * 100);
        return (
          <li
            key={item.localId}
            className="flex items-center gap-3 rounded-lg border border-grey-90 px-3 py-1.5 dark:border-primary-20"
          >
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm text-grey-20 dark:text-white">{item.fileName}</p>
              {item.attachment === null && (
                <div className="mt-1 flex items-center gap-2">
                  <div className="h-1 flex-1 overflow-hidden rounded-full bg-grey-90 dark:bg-primary-20">
                    <div className="h-full bg-primary-40 dark:bg-primary-90" style={{ width: `${percent}%` }} />
                  </div>
                  <span className="text-xs text-grey-40 dark:text-grey-80">{t("messages.attach.uploading")}</span>
                </div>
              )}
            </div>
            <button
              type="button"
              className="rounded-lg p-1 text-grey-40 hover:bg-grey-95 dark:text-grey-80 dark:hover:bg-primary-20"
              aria-label={`${t("common.remove")}: ${item.fileName}`}
              onClick={() => onRemove(item.localId)}
            >
              <X size={14} aria-hidden="true" />
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default PendingAttachments;
